import { ErrorMessage } from "src/model/error-message";
import { ShoppingCartItxDto } from "src/api/customer";

export interface CartUpdate {
    productId: number;
    type: 'ADDING' | 'REMOVING';
    error: ErrorMessage | null;
}

export interface ProductCheck {
    productId: number;
    error: ErrorMessage | null;
}

export interface CartState {
    content: ShoppingCartItxDto | null;
    hasUnavailableItems: boolean;
    unavailableIdItems: number[] | [];
    hasChangedItems: boolean;
    lastLoad: number;
    update: CartUpdate | null;
    productCheck: ProductCheck | null;
    paymentElementExpanded?: boolean;
    showAddressAlert: boolean;
}

export const initialCartState: CartState = {
    content: null,
    hasUnavailableItems: false,
    unavailableIdItems: [],
    hasChangedItems: false,
    lastLoad: 0,
    update: null,
    productCheck: null,
    paymentElementExpanded: false,
    showAddressAlert: false,
};